import { type ReactElement } from "react";
import { Text, Code } from "@citibox-panel/ui";

export function CodeDemo(): ReactElement {
  return (
    <>
      <Text variant="subtitle2" component="p">
        Box booked for booking{" "}
        <Code>df4f2e27-b249-4581-82a8-7d309fd9b65d</Code> related to expedition{" "}
        <Code>22e5ddcc-564f-407c-a689-055686db44f4</Code> with external reference{" "}
        <Code>N/A</Code>
      </Text>
      {/* Same component, smaller surrounding type: it tracks the paragraph rather than
          imposing a size, so it can sit in any row of the log table. */}
      <Text variant="body2" component="p">
        El mismo valor en un párrafo <Code>body2</Code>: el span adopta el tamaño de la
        prosa que interrumpe.
      </Text>
      {/* A 36-char id in a narrow measure wraps mid-token — the reason the background
          declares box-decoration-break: clone. */}
      <div style={{ maxWidth: 220, marginTop: 12 }}>
        <Text variant="body2" component="p">
          Envuelto: <Code>df4f2e27-b249-4581-82a8-7d309fd9b65d</Code>
        </Text>
      </div>
    </>
  );
}
